import { Award } from "lucide-react";
import useFetchingMyStats from "@/hooks/useFetchingMyStats";
import { memo } from "react";

const StatsCard = () => {
  const { connections, totalJourneys, weeksSinceFirst, isLoading } = useFetchingMyStats();

  if (isLoading) return null;

  if (!connections) {
    return (
      <div className="bg-card rounded-lg p-4 shadow-md">
        <div className="flex items-center mb-4">
          <Award className="text-secondary mr-2" />
          <h2 className="text-lg font-semibold text-card-foreground">Stats</h2>
        </div>
        <p className="text-muted-foreground italic">
          Join your first Nimi experience to unlock
        </p>
      </div>
    );
  }

  const statsToShow = [
    {
      label: 'Total Journeys',
      value: totalJourneys,
      show: totalJourneys > 0
    },
    {
      label: 'Weeks since your first Nimi',
      value: weeksSinceFirst,
      show: weeksSinceFirst > 0
    },
    {
      label: 'Nimi Connections',
      value: connections,
      show: connections > 0
    }
  ].filter(stat => stat.show);

  if (statsToShow.length === 0) {
    return (
      <div className="bg-card rounded-lg p-4 shadow-md">
        <div className="flex items-center mb-4">
          <Award className="text-secondary mr-2" />
          <h2 className="text-lg font-semibold text-card-foreground">Stats</h2>
        </div>
        <p className="text-muted-foreground italic">Join your first Nimi experience to unlock</p>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg p-4 shadow-md">
      <div className="flex items-center mb-4">
        <Award className="text-secondary mr-2" />
        <h2 className="text-lg font-semibold text-card-foreground">Stats</h2>
      </div>
      <div className="space-y-4">
        {statsToShow.map(stat => (
          <div key={stat.label}>
            <p className="text-sm text-muted-foreground">{stat.label}</p>
            <p className="text-2xl font-bold text-primary">{stat.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default memo(StatsCard);
